import { render, staticRenderFns } from "./EmailTranscriptModal.vue?vue&type=template&id=1573765f&"
import script from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1573765f')) {
      api.createRecord('1573765f', component.options)
    } else {
      api.reload('1573765f', component.options)
    }
    module.hot.accept("./EmailTranscriptModal.vue?vue&type=template&id=1573765f&", function () {
      api.rerender('1573765f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/EmailTranscriptModal.vue"
export default component.exports